var render = function render(){var _vm=this,_c=_vm._self._c;return _c('homepage',{attrs:{"page_slug":`homepage__${_vm.slider_variant}`,"slider_variant":_vm.slider_variant,"default_blocks":_vm.default_blocks,"site_blocks":_vm.site_blocks}})
}
var staticRenderFns = []

export { render, staticRenderFns }